module.exports = __webpack_public_path__ + "static/mr-press-22-0838d62912ec7a76d67e072f47a17d69.jpg";